import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RentalService {
    private URL: string = 'api/rental';

    constructor(private httpService: HttpClient) {}

    create(storageLocation: any) {
        return this.httpService.post(this.URL, storageLocation);
    }

    process(subId: string, payload: any) {
        return this.httpService.post(`api/rental/process/${subId}`, payload);
    }

    setStatusByAdmin(subId: string, payload: any) {
        return this.httpService.post(`api/rental/admin/status/${subId}`, payload);
    }

    preCancel(subId: string, payload: any) {
        return this.httpService.post(`api/rental/precancel/${subId}`, payload);
    }

    cancel(subId: string, payload: any) {
        return this.httpService.post(`api/rental/cancel/${subId}`, payload);
    }

    expireSession(stripeCheckoutSessionId: string) {
        return this.httpService.delete(
            `api/rental/expire/${stripeCheckoutSessionId}`,
        );
    }

    regeneatePdf(rentalId: string) {
        return this.httpService.post(
            `${this.URL}/generateContratct/${rentalId}`,
            {},
        );
    }

    getStatsForLocation(locationId) {
        return this.httpService.get(`api/rental/location/stats/${locationId}`);
    }

    getAll() {
        return this.httpService.get(`${this.URL}/location`);
    }

    getAllForLocation(locationId: string) {
        return this.httpService.get(`${this.URL}/location/${locationId}`);
    }

    getAllForUser() {
        return this.httpService.get(`api/rental/user`);
    }

    // Admin: alle Rentals eines Kunden über alle Standorte (Kundenakte)
    getAllForUserAsAdmin(sub: string) {
        return this.httpService.get(`${this.URL}/admin/by-user/${sub}`);
    }

    getCancellationDate(subId: string) {
        return this.httpService.get(`${this.URL}/getCancellationDate/${subId}`);
    }

    getOne(id: string) {
        return this.httpService.get(`${this.URL}/location/${id}`);
    }

    update(id: string, payload: any) {
        return this.httpService.patch(`${this.URL}/${id}`, payload);
    }

    delete(id: string) {
        return this.httpService.delete(`${this.URL}/${id}`);
    }
    checkWithinSubscription(subId: string, dateToCheck: string) {
        return this.httpService.get(`${this.URL}/checkWithinSubscription/${subId}?date=${dateToCheck}`);
    }
}
